import { ChatPanelRoot } from "./ChatPanel";
import { ChatPanelHeader } from "./ChatPanelHeader";
import { ChatPanelMessages } from "./ChatPanelMessages";
import { ChatPanelContextCard } from "./ChatPanelContextCard";
import { ChatPanelQuickActions } from "./ChatPanelQuickActions";
import { ChatPanelInput } from "./ChatPanelInput";

export const ChatPanel = Object.assign(ChatPanelRoot, {
  Header: ChatPanelHeader,
  Messages: ChatPanelMessages,
  ContextCard: ChatPanelContextCard,
  QuickActions: ChatPanelQuickActions,
  Input: ChatPanelInput,
});

export { ChatPanelProvider, useChatPanel } from "./ChatPanelContext";
export { GlobalChatPanel } from "./GlobalChatPanel";
export { ChatContextChips } from "./ChatContextChips";
export { MentionPopover } from "./MentionPopover";
export { GlobalChatInput } from "./GlobalChatInput";
export type {
  ChatMessage,
  ToolPart,
  ChatPanelContextType,
  ChatPanelProps,
  ChatPanelHeaderProps,
  ChatPanelMessagesProps,
  ChatPanelContextCardProps,
  QuickAction,
  ChatPanelQuickActionsProps,
  ChatPanelInputProps,
  ChatPanelInputContext,
} from "./types";
